import { fetchData, APIMethod, ACCESS_DOMAINS } from "@client";

export async function storeProjectBudgetTrackingQuery(projectUuid, versionKey, userId, jiraProjectKey, jiraWorkspaceId) {
  return await fetchData(`api/export/project`, APIMethod.POST, {
    baseURL: ACCESS_DOMAINS.btApi,
    data: {
      projectJiraId: jiraProjectKey,
      jiraAppId: jiraWorkspaceId,
      projectId: projectUuid,
      version: versionKey,
      userId,
    },
  });
}
